module.exports = __webpack_public_path__ + "img/holigala.c77e63f9.png";